/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BigNumberish,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Marketplace, MarketplaceInterface } from "../Marketplace";

const _abi = [
  {
    inputs: [
      {
        internalType: "address payable",
        name: "_controlCenter",
        type: "address",
      },
      {
        internalType: "address",
        name: "_trustedForwarder",
        type: "address",
      },
      {
        internalType: "address",
        name: "_nativeTokenWrapper",
        type: "address",
      },
      {
        internalType: "string",
        name: "_uri",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "_marketFeeBps",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "timeBuffer",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "bidBufferBps",
        type: "uint256",
      },
    ],
    name: "AuctionBuffersUpdated",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "listingId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "closer",
        type: "address",
      },
      {
        indexed: true,
        internalType: "bool",
        name: "cancelled",
        type: "bool",
      },
      {
        indexed: false,
        internalType: "address",
        name: "auctionCreator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "winningBidder",
        type: "address",
      },
    ],
    name: "AuctionClosed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "bool",
        name: "restricted",
        type: "bool",
      },
    ],
    name: "ListingRestricted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "listingId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "listingCreator",
        type: "address",
      },
    ],
    name: "ListingUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "newFee",
        type: "uint64",
      },
    ],
    name: "MarketFeeUpdate",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "listingId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "assetContract",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "lister",
        type: "address",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "listingId",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "tokenOwner",
            type: "address",
          },
          {
            internalType: "address",
            name: "assetContract",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "startTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "endTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "quantity",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "currency",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "reservePricePerToken",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "buyoutPricePerToken",
            type: "uint256",
          },
          {
            internalType: "enum IMarketplace.TokenType",
            name: "tokenType",
            type: "uint8",
          },
          {
            internalType: "enum IMarketplace.ListingType",
            name: "listingType",
            type: "uint8",
          },
        ],
        indexed: false,
        internalType: "struct IMarketplace.Listing",
        name: "listing",
        type: "tuple",
      },
    ],
    name: "NewListing",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "listingId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "offeror",
        type: "address",
      },
      {
        indexed: true,
        internalType: "enum IMarketplace.ListingType",
        name: "listingType",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "quantityWanted",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "totalOfferAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "address",
        name: "currency",
        type: "address",
      },
    ],
    name: "NewOffer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "listingId",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "address",
        name: "assetContract",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "lister",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "buyer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "quantityBought",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "totalPricePaid",
        type: "uint256",
      },
    ],
    name: "NewSale",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "LISTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MAX_BPS",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "NATIVE_TOKEN",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "VERSION",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_listingId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "offeror",
        type: "address",
      },
    ],
    name: "acceptOffer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "bidBufferBps",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_listingId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_quantityToBuy",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_currency",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_totalPrice",
        type: "uint256",
      },
    ],
    name: "buy",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_listingId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_closeFor",
        type: "address",
      },
    ],
    name: "closeAuction",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "contractURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "assetContract",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "tokenId",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "startTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "secondsUntilEndTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "quantityToList",
            type: "uint256",
          },
          {
            internalType: "address",
            name: "currencyToAccept",
            type: "address",
          },
          {
            internalType: "uint256",
            name: "reservePricePerToken",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "buyoutPricePerToken",
            type: "uint256",
          },
          {
            internalType: "enum IMarketplace.ListingType",
            name: "listingType",
            type: "uint8",
          },
        ],
        internalType: "struct IMarketplace.ListingParameters",
        name: "_params",
        type: "tuple",
      },
    ],
    name: "createListing",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "forwarder",
        type: "address",
      },
    ],
    name: "isTrustedForwarder",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "listings",
    outputs: [
      {
        internalType: "uint256",
        name: "listingId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "tokenOwner",
        type: "address",
      },
      {
        internalType: "address",
        name: "assetContract",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "startTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "endTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "quantity",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "currency",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "reservePricePerToken",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "buyoutPricePerToken",
        type: "uint256",
      },
      {
        internalType: "enum IMarketplace.TokenType",
        name: "tokenType",
        type: "uint8",
      },
      {
        internalType: "enum IMarketplace.ListingType",
        name: "listingType",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "marketFeeBps",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes[]",
        name: "data",
        type: "bytes[]",
      },
    ],
    name: "multicall",
    outputs: [
      {
        internalType: "bytes[]",
        name: "results",
        type: "bytes[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "nativeTokenWrapper",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_listingId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_quantityWanted",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_currency",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_pricePerToken",
        type: "uint256",
      },
    ],
    name: "offer",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "offers",
    outputs: [
      {
        internalType: "uint256",
        name: "listingId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "offeror",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "quantityWanted",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "currency",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "pricePerToken",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155BatchReceived",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC721Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "restrictedListerRoleOnly",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_timeBuffer",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_bidBufferBps",
        type: "uint256",
      },
    ],
    name: "setAuctionBuffers",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_uri",
        type: "string",
      },
    ],
    name: "setContractURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_feeBps",
        type: "uint256",
      },
    ],
    name: "setMarketFeeBps",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bool",
        name: "restricted",
        type: "bool",
      },
    ],
    name: "setRestrictedListerRoleOnly",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "timeBuffer",
    outputs: [
      {
        internalType: "uint64",
        name: "",
        type: "uint64",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalListings",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_listingId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_quantityToList",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_reservePricePerToken",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_buyoutPricePerToken",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_currencyToAccept",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_startTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_secondsUntilEndTime",
        type: "uint256",
      },
    ],
    name: "updateListing",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "winningBid",
    outputs: [
      {
        internalType: "uint256",
        name: "listingId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "offeror",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "quantityWanted",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "currency",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "pricePerToken",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    stateMutability: "payable",
    type: "receive",
  },
];

const _bytecode =
  "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";

type MarketplaceConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MarketplaceConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Marketplace__factory extends ContractFactory {
  constructor(...args: MarketplaceConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(
    _controlCenter: string,
    _trustedForwarder: string,
    _nativeTokenWrapper: string,
    _uri: string,
    _marketFeeBps: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Marketplace> {
    return super.deploy(
      _controlCenter,
      _trustedForwarder,
      _nativeTokenWrapper,
      _uri,
      _marketFeeBps,
      overrides || {}
    ) as Promise<Marketplace>;
  }
  getDeployTransaction(
    _controlCenter: string,
    _trustedForwarder: string,
    _nativeTokenWrapper: string,
    _uri: string,
    _marketFeeBps: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _controlCenter,
      _trustedForwarder,
      _nativeTokenWrapper,
      _uri,
      _marketFeeBps,
      overrides || {}
    );
  }
  attach(address: string): Marketplace {
    return super.attach(address) as Marketplace;
  }
  connect(signer: Signer): Marketplace__factory {
    return super.connect(signer) as Marketplace__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MarketplaceInterface {
    return new utils.Interface(_abi) as MarketplaceInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Marketplace {
    return new Contract(address, _abi, signerOrProvider) as Marketplace;
  }
}
